import styled from 'styled-components';

export const IconStyled = styled.img`

`;
